import { auth } from '../config/firebase';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

async function authHeaders(): Promise<Record<string, string>> {
  const user = auth.currentUser;
  if (!user) return {};
  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

export interface SummaryOrder {
  eventName: string;
  orderDate: string | null;
  eventDate: string | null;
  qty: number;
  category: string;
  revenue: number;
  platform: string;
  boughtFrom: string;
  cost: number | null; // total GBP cost of the order; null = not recorded
  buyer: string; // hashed buyer identity
  resold: boolean;
  resoldQty: number;
  deliveredAt: string | null;
  deliveryMethod: string;
}

export interface SummaryExpense { date: string; category: string; vendor: string; amountGBP: number; source: string }

export interface SummaryStock {
  _id: string; kind: 'event' | 'season'; eventName: string; eventDate?: string | null; team: string; quantity: number; category: string;
  pricePerTicket: number; boughtFrom: string; assignedTotal: number; remaining?: number;
  usage?: { eventName: string; date: string | null; used: number; remaining: number }[];
}

export interface MarketEvent { eventName: string; day: string; source: 'live' | 'stubhub'; sales: number; tickets: number; revenue: number; mySales: number; myTickets: number; medianPrice: number }
export interface MarketMonth { month: string; source: 'live' | 'stubhub'; sales: number; tickets: number; revenue: number }
export interface ListingEvent { platform: string; eventName: string; eventDate: string | null; updatedAt: string | null; myListings: number; categories: { name: string; myMin: number; compMin: number; count: number }[] }
export interface FloorStat { platform: string; listings: number; sampled: number; withFloor: number; atFloor: number; below: number; within5: number; within15: number; above: number }

export interface SummaryData {
  generatedAt: string;
  orders: SummaryOrder[];
  expenses: SummaryExpense[];
  stock: SummaryStock[];
  market: { events: MarketEvent[]; months: MarketMonth[] };
  listings: { events: ListingEvent[]; floors: FloorStat[] };
}

export async function fetchSummary(refresh = false): Promise<SummaryData> {
  const headers = await authHeaders();
  const res = await axios.get(`${API_URL}/summary/data${refresh ? '?refresh=1' : ''}`, { headers, timeout: 120000 });
  return res.data;
}
